<template>
  <tr>
    <!-- <p>{{ ItemRow }}</p> -->
    <td>{{ ItemRow.ItemName }}</td>
    <!-- <td>{{ ItemRow.qty.toLocaleString() }} ({{ ItemRow.UnitType }})</td> -->
    <td>
      <strong> {{ UnitPrice.toLocaleString() }}</strong>
    </td>
    <td>
      <strong>
        {{ UnitCost.toLocaleString() }}
      </strong>
    </td>
    <td>
      <strong> {{ TotalCost.toLocaleString() }}</strong>
    </td>
    <td>
      <v-text-field
        class="mt-5"
        :name="'Sellname' + ItemRow._id"
        outlined
        dense
        label="Selling Price"
        :id="'SellingID' + ItemRow._id"
        :rules="[IsNum, isGoingLose]"
        :value="ItemRow.SellingPrice.toLocaleString()"
        :prefix="SellPrecentage + ' %: '"
        @input="InputEventQty"
      ></v-text-field>
    </td>
  </tr>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins.js";
export default {
  mixins: [tokenMixin],
  props: {
    ItemRow: { type: Object, required: true },
    expense: { type: Number, required: true },
    rate: { type: Number, default: 1 },
    margin: { type: [Number, String], default: 0 },
    margType: { type: String, default: "%" },
  },

  computed: {
    UnitPrice() {
      return this.ItemRow.unitPrice * this.rate;
    },
    UnitCost() {
      return parseFloat(
        (this.ItemRow.unitPrice * this.rate * this.expense).toFixed(2)
      );
    },
    TotalCost() {
      return parseFloat((this.UnitPrice + this.UnitCost).toFixed(2));
    },
    SellPrecentage() {
      let ration = (this.ItemRow.SellingPrice - this.TotalCost) * 100;
      //   console.log(ration);
      if (this.TotalCost == 0) return ration.toLocaleString();
      return parseFloat((ration / this.TotalCost).toFixed(2));
    },
  },

  watch: {
    margType(v) {
      if (v === "#" && this.margin > 0)
        this.ItemRow.SellingPrice = this.TotalCost + this.margin;
      else if (v === "%" && this.margin > 0)
        this.ItemRow.SellingPrice =
          this.TotalCost * (this.margin / 100) + this.TotalCost;
    },
    margin(v) {
      if (v && v > 0) {
        if (this.margType === "%")
          this.ItemRow.SellingPrice =
            this.TotalCost * (v / 100) + this.TotalCost;
        else if (this.margType === "#")
          this.ItemRow.SellingPrice = this.TotalCost + v;
        // console.log(this.ItemRow.SellingPrice);
      } else
        this.ItemRow.SellingPrice = this.TotalCost * (0 / 100) + this.TotalCost;
    },
    TotalCost(val) {
      this.ItemRow.SellingPrice = val;
    },
    rate(val) {
      this.ItemRow.convertRate = val;
      // console.log(this.ItemRow);
    },
    UnitCost(val) {
      this.ItemRow.unitCost = val;
    },
  },

  methods: {
    IsNum(v) {
      if (!isNaN(v.replace(/,/g, ""))) return true;
      return "it is not number";
    },
    isGoingLose(v) {
      if (parseFloat(v.replace(/,/g, "")).toFixed(2) < this.TotalCost)
        return "you are loosing";
      return true;
    },

    InputEventQty(v) {
      // console.log("00000");
      if (isNaN(v.replace(/,/g, ""))) return;
      this.ItemRow.SellingPrice = parseFloat(v.replace(/,/g, "")) || 0;
    },
  },
  mounted() {
    this.ItemRow.SellingPrice = this.TotalCost;
  },
};
</script>
